<template>
    <div class="bread-crumb-bar">
      <div class="row">
        <div class="col-sm-1">
          <div class="flag-box">
            <img :src="source" alt="">
          </div>
        </div>
        <div class="col-sm-11">
          <p class="breadcrumb-path-container">
            <router-link v-for="(path, index) in breadcrumbPath"
                        :to="breadcrumbLink(path)"
                        class="breadcrumb-path"
                        :key="index">
              {{ breadcrumbDisplay(path) }}
            </router-link>
          </p>
        </div>
      </div>

    </div>
</template>


<script type="text/javascript">
import { mapState } from 'vuex'
import _ from 'lodash'

export default {
  props:{
    flag:{
      default: "jamaica.svg"
    }

  },
    data () {
        return {
          displayMap: {
            'customers': {'store': 'customers', 'fields':['first_name','last_name']},
            'policies': {'store': 'policies', 'fields':['policy_number']},
            'quotation': {'store': 'quotation', 'fields': ['quotation_number']},
          },
        }
    },
    methods:{
      breadcrumbLink: function(pathName){
        if (!this.pathNameIndex(pathName)){
          return '/' + [pathName.toLowerCase()].join('/');
        }
        if (this.pathNameIndex(pathName) === this.breadcrumbPath.length - 1){
          return "";
        }

        let previousPathName = this.breadcrumbPath[this.pathNameIndex(pathName) -1]
        if (this.isCurrentLocation(pathName)){
          return this.breadcrumbLink(previousPathName);
        } else {
          if (typeof pathName !== 'number'){
            return [this.breadcrumbLink(previousPathName), pathName.toLowerCase()].join('/');
          } else {
            return [this.breadcrumbLink(previousPathName), pathName].join('/')
          }
        }
      },
      breadcrumbDisplay: function(pathName){
        if (typeof pathName === 'number'){
          let lookup = this.breadcrumbPath[this.pathNameIndex(pathName) - 1];
          if (this.displayMap.hasOwnProperty(lookup.toLowerCase())){
            let display_params = this.displayMap[lookup.toLowerCase()]['fields'];
            let store = this;
            display_params = display_params.map(
              field => {
                let storeName = this.displayMap[lookup.toLowerCase()]['store']
                return this.selectedCustomer[field];
              }
            );
            return display_params.join(' ');
          }
        }else {
          if (pathName.includes('-')){
            pathName = pathName.split('-').map(path => _.capitalize(path)).join(' ');
          }
          return pathName;
        }
      },
      isCurrentLocation: function(path){
        return this.pathNameIndex(path) === this.breadcrumbPath.length - 1;

      },
      pathNameIndex: function(path){
        return this.breadcrumbPath.indexOf(path)
      },
      pathNameGivenIndex: function(index){
        return this.breadcrumbPath[index];
      }
    },
    computed: {
        ...mapState({
          customers: state => state.customers,
          selectedCustomer: state => state.selectedCustomer,
        }),
        source: function(){
          return require('./../assets/' + this.flag)
        },
        currentPath: function() {
            return this.$route.fullPath
        },
        breadcrumbPath: function(){
          let path_sections = this.currentPath.split('/').map(section => {
            let isInt = Number.parseInt(section);
            if (!isInt) {
              section = _.capitalize(section);
            } else { section = isInt; }
            return section
          });

          return path_sections.filter(section => {
            if (typeof section === 'string'){
              return section.length > 0;
            }
            if (typeof section === 'number'){
              return section > 0;
            }
          });

        }
    }
}
</script>


<style lang="scss" scoped>
@import "../css/constants";

//Reset
.col-lg-1, .col-lg-10, .col-lg-11, .col-lg-12, .col-lg-2, .col-lg-3, .col-lg-4, .col-lg-5, .col-lg-6, .col-lg-7, .col-lg-8, .col-lg-9, .col-md-1, .col-md-10, .col-md-11, .col-md-12, .col-md-2, .col-md-3, .col-md-4, .col-md-5, .col-md-6, .col-md-7, .col-md-8, .col-md-9, .col-sm-1, .col-sm-10, .col-sm-11, .col-sm-12, .col-sm-2, .col-sm-3, .col-sm-4, .col-sm-5, .col-sm-6, .col-sm-7, .col-sm-8, .col-sm-9, .col-xs-1, .col-xs-10, .col-xs-11, .col-xs-12, .col-xs-2, .col-xs-3, .col-xs-4, .col-xs-5, .col-xs-6, .col-xs-7, .col-xs-8, .col-xs-9 {
  padding: 0;
  margin: 0;
  width: auto;
}
.row {
  margin: 0;
  padding-top: $p24;
  padding-bottom: $p24;
}

.flag-box img{
  height:100%;
  width:100%;
}
.flag-box{
  height:15px;
  width: 21px;
}
.bread-crumb-bar{
  background-color: white;
  padding-left: $p24;
  margin-left: -$p24;
  padding-right: $p24;
  margin-right: -$p24;
}
.breadcrumb-path-container {
  line-height: 1.2;
  margin-left: $p14;
}
.breadcrumb-path:hover{
  text-decoration: none;

}
.breadcrumb-path {
  text-decoration: none;
  color: $gray7;
  font-family: "Roboto";
  font-weight: 'regular';
  &:last-of-type{
    margin-left: 0;
    font-family: "Roboto";
    font-weight: 'medium';
  }

  &:after{
    content: url('../assets/right-arrow.svg');
    padding-right:5px;
    padding-left:5px;
  }

  &:last-of-type{
    &:after{
      content: none;
    }
  }
}
// @media (min-width: 576px){
//   .col-sm-1 {
//     -webkit-box-flex: 0;
//     -webkit-flex: 0 0 8.333333%;
//     -ms-flex: 0 0 8.333333%;
//     flex: 0 0 8.333333%;
//     max-width: 2.333333%;
//   }
// }


</style>



// WEBPACK FOOTER //
// src/components/BreadcrumbBar.vue